import { render } from "./QuickExit.vue?vue&type=template&id=022eb8ab"
import script from "./QuickExit.vue?vue&type=script&lang=js"
export * from "./QuickExit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__